<div class="relative flex flex-col items-center" *ngrxLet="viewModel$; let model">
  <div class="flex items-center">
    <div #previousSlideButton
         (click)="previousSlide($event)"
         class="buttonLarge"
         [ngClass]="{ 'absolute': insetControls,
                      'mr-2': !insetControls,
                      'invisible': !model?.activeSlideIndex }"
         [style.left.px]="8"
         [style.top.px]="model.containerHeight / 2 - previousSlideButton.offsetHeight / 2">
      <mat-icon svgIcon="chevron_left"></mat-icon>
    </div>

    <div #slideContainer
         [style.width.px]="model.containerWidth"
         class="slideContainer">
      <ng-content></ng-content>
    </div>

    <div #nextSlideButton
         (click)="nextSlide($event)"
         class="buttonLarge"
         [ngClass]="{ 'absolute': insetControls,
                      'ml-2': !insetControls,
                      'invisible': model?.activeSlideIndex === slides?.length - 1 }"
         [style.right.px]="8"
         [style.top.px]="model.containerHeight / 2 - nextSlideButton.offsetHeight / 2">
      <mat-icon svgIcon="chevron_right"></mat-icon>
    </div>
  </div>

  @if (slides?.length > 1) {
    <div class="slideNav"
         #slideNav
         (click)="$event.stopPropagation()"
         [ngClass]="{ 'absolute': insetControls,
                    'mt-2': !insetControls }"
         [style.bottom.px]="8"
         [style.left.px]="model.containerWidth / 2 - slideNav.offsetWidth / 2">
      @for (slide of slides; let i = $index; track i) {
        <div (click)="scrollToSlide(i)"
             class="buttonSmall"
             [ngClass]="{'active': i === model.activeSlideIndex}"></div>
      }
    </div>
  }
</div>